export const ageMethod = "age nearest";
export const gateway = "https://qat-jeminsurance-api.link-nonprod.wawanesalife.com";
export const assets = "https://qat-assets.link-nonprod.wawanesalife.com/brokers/jeminsurance";
export const googleApiKey = "AIzaSyD8GAXLH7FxUmF13tfHgXVAU6fWk66UH3k";
export const appToken = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJqZW1pbnN1cmFuY2UiLCJuYW1lIjoiamVtaW5zdXJhbmNlIiwiaWF0IjoxNzgwNTgxMTQ0LCJleHAiOjE5MzgzNjkxNDR9.RALR8iOTYUoSnhdfMF9760Myr-BOtk_WpyA2hOXlQMA";
export const brokerConfig = {
	enabled: "yes",
	"split": '0.6'
};
export const brokerBranding = {
	"qat-jeminsurance-shopper.link-nonprod.wawanesalife.com": {
		a: {
			approve_company: "Link Platform",
			approve_user: "link_jeminsurance",
			brands: [
				"qat-jeminsurance-shopper.link-nonprod.wawanesalife.com",
			],
			broker: "jeminsurance",
			broker_formatted_name: "JEM Insurance",
			email: "info@jeminsurance.ca",
			environment: "qat",
			environment_id: "qat",
			formLabels: "show",
			layout: "flat",
			logoPosition: "menu",
			map1: [
				"987 Portage Avenue",
				"Winnipeg",
				"MB",
				"R3G 0R7",
			],
			map2: [
				"12-963 Henderson Hwy",
				"Winnipeg",
				"MB",
				"R2K 2M3",
			],
			map3: [
				"9-35 Lakewood Boulevard",
				"Winnipeg",
				"MB",
				"R2J 2M8",
			],
			map4: [
				"640 Central Avenue",
				"Ste Rose du Lac",
				"MB",
				"R0L 1S0",
			],
			"maps": {
				"map4": [
					"640 Central Avenue",
					"Ste Rose du Lac",
					"MB",
					"R0L 1S0",
				],
				"map3": [
					"9-35 Lakewood Boulevard",
					"Winnipeg",
					"MB",
					"R2J 2M8",
				],
				"map2": [
					"12-963 Henderson Hwy",
					"Winnipeg",
					"MB",
					"R2K 2M3",
				],
				"map1": [
					"987 Portage Avenue",
					"Winnipeg",
					"MB",
					"R3G 0R7",
				],
			},
			menuPhone: "button",
			phone: "204-774-4471",
			photo1: "hide",
			photo2: "hide",
			photo3: "hide",
			photo4: "hide",
			privacyLink: "https://jeminsurance.ca/privacy-policy/",
			tagline: "We’re here to help",
			website: "https://jeminsurance.ca",
			scope: "jeminsurance#branding#qat-jeminsurance-shopper.link-nonprod.wawanesalife.com#a",
			ab: "a",
			logo: "a.png",
			brand_name: "qat-jeminsurance-shopper.link-nonprod.wawanesalife.com",
		},
		b: {
			approve_company: "Link Platform",
			approve_user: "link_jeminsurance",
			brands: [
				"qat-jeminsurance-shopper.link-nonprod.wawanesalife.com",
			],
			broker: "jeminsurance",
			broker_formatted_name: "JEM Insurance",
			email: "info@jeminsurance.ca",
			environment: "qat",
			environment_id: "qat",
			formLabels: "show",
			layout: "flat",
			logoPosition: "menu",
			map1: [
				"987 Portage Avenue",
				"Winnipeg",
				"MB",
				"R3G 0R7",
			],
			map2: [
				"12-963 Henderson Hwy",
				"Winnipeg",
				"MB",
				"R2K 2M3",
			],
			map3: [
				"9-35 Lakewood Boulevard",
				"Winnipeg",
				"MB",
				"R2J 2M8",
			],
			map4: [
				"640 Central Avenue",
				"Ste Rose du Lac",
				"MB",
				"R0L 1S0",
			],
			"maps": {
				"map4": [
					"640 Central Avenue",
					"Ste Rose du Lac",
					"MB",
					"R0L 1S0",
				],
				"map3": [
					"9-35 Lakewood Boulevard",
					"Winnipeg",
					"MB",
					"R2J 2M8",
				],
				"map2": [
					"12-963 Henderson Hwy",
					"Winnipeg",
					"MB",
					"R2K 2M3",
				],
				"map1": [
					"987 Portage Avenue",
					"Winnipeg",
					"MB",
					"R3G 0R7",
				],
			},
			menuPhone: "button",
			phone: "204-774-4471",
			photo1: "hide",
			photo2: "hide",
			photo3: "hide",
			photo4: "hide",
			privacyLink: "https://jeminsurance.ca/privacy-policy/",
			tagline: "We’re here to help",
			website: "https://jeminsurance.ca",
			scope: "jeminsurance#branding#qat-jeminsurance-shopper.link-nonprod.wawanesalife.com#b",
			ab: "b",
			logo: "b.png",
			brand_name: "qat-jeminsurance-shopper.link-nonprod.wawanesalife.com",
		},
	},
};

//updated on Thu Jun 04 2026 13:52:24 GMT+0000 (Coordinated Universal Time)
